module.exports = __webpack_public_path__ + "img/brief-bg.fd69853d.png";